export const SCORE_TEXT_TOKEN = "{{puntos}}";
export const SCORE_TEXT_ROLE = "score";

export function isScoreTextElement(content) {
	return content?.textRole === SCORE_TEXT_ROLE;
}

export function defaultScoreTextHtml() {
	return `<p>${SCORE_TEXT_TOKEN}</p>`;
}

export function renderScoreTextHtml(html, score) {
	const template = html || defaultScoreTextHtml();
	const n = Number(score);
	const val = Number.isFinite(n) ? String(Math.trunc(n)) : "0";
	return String(template).split(SCORE_TEXT_TOKEN).join(val);
}

export function ensureScoreTextTemplateHtml(html) {
	const raw = String(html || "").trim();
	if (!raw) return defaultScoreTextHtml();
	if (raw.includes(SCORE_TEXT_TOKEN)) return raw;
	if (/<\/p>\s*$/i.test(raw)) {
		return raw.replace(/<\/p>\s*$/i, ` ${SCORE_TEXT_TOKEN}</p>`);
	}
	return `${raw} ${SCORE_TEXT_TOKEN}`;
}

export function resolveScoreTextDisplayHtml(content, score, { editing = false } = {}) {
	const template = content?.html || defaultScoreTextHtml();
	if (editing) return ensureScoreTextTemplateHtml(template);
	return renderScoreTextHtml(template, score);
}
